import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const CustomAttributes = ({ customAttributes }) =>
  customAttributes.map(
    (attribute) =>
      attribute && (
        <Attribute key={attribute.custom_attr_id} attribute={attribute} />
      ),
  );

const Attribute = ({ attribute }) => (
  <Box mt="6px" flexDirection="column">
    <Label mr={1}>{attribute.display_name}</Label>
    <Value>{attribute.display_value}</Value>
  </Box>
);

CustomAttributes.propTypes = {
  customAttributes: PropTypes.array,
};

export default CustomAttributes;

const Label = styled(Box).attrs(() => ({
  font: 'metadata-semibold-asphalt',
  fontSize: 1,
  mr: 1,
  as: 'span',
  display: 'inline',
}))``;

const Value = styled(Box).attrs(() => ({
  font: 'metadata-regular-asphalt',
  fontSize: 1,
  mr: 1,
  as: 'span',
  display: 'inline',
}))``;
